import React from "react"

import { Wrapper, StyledHeading, Accordion } from "./styles"

const HeadingAccordion = ({ element, background, children }) => (
  <Wrapper>
    <Accordion
      title={<StyledHeading element={element} />}
      background={background}
      isArticleFAQ
      level={element.level}
    >
      {children}
    </Accordion>
  </Wrapper>
)

export default HeadingAccordion
